import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const postClubStaffData = (orgUnitId, roleGroupId, clubStaffObj, removeRoles, state, setState) => {
  if (orgUnitId && roleGroupId > 0 && clubStaffObj) {
    const api = initApi(API_NAMES.COMMON, state, setState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const roleGroupIdForUrl = roleGroupId ? encodeURIComponent(roleGroupId) : 'NaN';

    const url = `/OrgUnit/${orgUnitIdForUrl}/staff/roleGroup/${roleGroupIdForUrl}?removeRoles=${removeRoles}`;

    return api.executeObject ? api.executeObject(url, 'POST', clubStaffObj) : null;
  }
};

const getClubStaffMembersData = (orgUnitId, roleGroupId, isCurrentOnly = true, state, setState) => {
  if (orgUnitId && roleGroupId > 0) {
    const api = initApi(API_NAMES.COMMON, state, setState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const roleGroupIdForUrl = roleGroupId ? encodeURIComponent(roleGroupId) : 'NaN';

    const url = `/OrgUnit/${orgUnitIdForUrl}/staff/roleGroup/${roleGroupIdForUrl}?isCurrentOnly=${isCurrentOnly}`;

    return api.executeArray ? api.executeArray(url, 'GET') : null;
  }
};

const putClubStaffData = (orgUnitId, roleGroupId, personId, clubStaffObj, state, setState) => {
  if (orgUnitId && personId && roleGroupId > 0 && clubStaffObj) {
    const api = initApi(API_NAMES.COMMON, state, setState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const roleGroupIdForUrl = roleGroupId ? encodeURIComponent(roleGroupId) : 'NaN';
    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;

    const url = `/OrgUnit/${orgUnitIdForUrl}/staff/roleGroup/${roleGroupIdForUrl}/person/${personIdForUrl}`;

    return api.executeObject ? api.executeObject(url, 'PUT', clubStaffObj) : null;
  }
};

const deleteClubStaffRoleData = (personOrgRoleDurationId, state, setState) => {
  if (personOrgRoleDurationId > 0) {
    const api = initApi(API_NAMES.PERSON, state, setState);

    const personOrgRoleDurationIdForUrl = personOrgRoleDurationId ? encodeURIComponent(personOrgRoleDurationId) : 'NaN';
    
    const url = `/PersonOrgRoleDuration/${personOrgRoleDurationIdForUrl}`;

    return api.executeObject ? api.executeObject(url, 'DELETE') : null;
  }
};

const INITIAL_CLUB_STAFF_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_CLUB_STAFF_POST_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_CLUB_STAFF_PUT_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_CLUB_STAFF_DELETE_STATE = {
  ...BASIC_INITIAL_STATE
};

const ClubStaffData = {
  INITIAL_CLUB_STAFF_STATE,
  INITIAL_CLUB_STAFF_POST_STATE,
  INITIAL_CLUB_STAFF_PUT_STATE,
  INITIAL_CLUB_STAFF_DELETE_STATE,
  postClubStaffData,
  getClubStaffMembersData,
  putClubStaffData,
  deleteClubStaffRoleData
};

export default ClubStaffData;